module.exports = __webpack_public_path__ + "0011caa176259876615c911e038c1575.svg";